import React from 'react';
import { Routes, Route } from "react-router-dom";
import PrivateAuth from '../../authorization/PrivateAuth';
import Salesordermanual from "../../../pages/Outbound/Sales-Order/Sales-Order-Manual/Sales-order-manual";
import Createsales from "../../../pages/Outbound/Sales-Order/Sales-Order-Manual/Create-Sales-Order/Create";
import Createpick from "../../../pages/Outbound/Create-Pick/Create-Pick/Create-pick";
import Picklist from "../../../pages/Outbound/Create-Pick/Pick-list/Pick-list";
import Delivery from '../../../pages/Outbound/Delivery-Note/Delivery';
import Createdelivery from '../../../pages/Outbound/Delivery-Note/Create-delivery-note/Create';
import Packingslip from '../../../pages/Outbound/Packing-Slip/Packingslip';
import Createpackingslip from '../../../pages/Outbound/Packing-Slip/Create-packing-slip/Createpackingslip';
import Notfound from "../../../pages/Notfound";
import Create from '../../../pages/Outbound/Packing-Slip/Create-packing-slip/Create';
import SalesOrderView from '../../../pages/Outbound/Sales-Order/Sales-Order-Manual/view-sales-Order/SalesOrderView';
import CreatepickNew from '../../../pages/Outbound/Create-Pick/Create-Pick-New/CreatepickNew';
import Viewpick from '../../../pages/Outbound/Create-Pick/View-Pick/Viewpick';
import ViewDeliverynote from '../../../pages/Outbound/Delivery-Note/View-delivery-note/Create';
import EditDeliverynote from '../../../pages/Outbound/Delivery-Note/Edit-delivery-note/Create';
import EditSalesOrder from '../../../pages/Outbound/Sales-Order/Sales-Order-Manual/Edit-Sales-Order/EditSalesOrder';
import ViewPackSlip from '../../../pages/Outbound/Packing-Slip/view-packing-slip/ViewPackSlip';
import Editpick from '../../../pages/Outbound/Create-Pick/Edit-Pick/Editpick';
import DuplicateSalesOrder from '../../../pages/Outbound/Sales-Order/Sales-Order-Manual/Duplicate-Sales-Order/DuplicateSalesOrder';
import ShipmentList from '../../../pages/Outbound/Shipments/ShipmentList';
import ShipmentCreate from '../../../pages/Outbound/Shipments/createshipment/ShipmentCreate';
import ShipmentEdit from '../../../pages/Outbound/Shipments/editshipment/ShipmentEdit';
import ShipmentView from '../../../pages/Outbound/Shipments/viewshipment/ShipmentView';
import SalesInvoice from '../../../pages/Outbound/SalesInvoice/SalesInvoice';
import SalesInvoiceCreate from '../../../pages/Outbound/SalesInvoice/Create-Sales-Order/SalesInvoiceCreate';
import SalesInvoiceEdit from '../../../pages/Outbound/SalesInvoice/Edit-Sales-Invoice/SalesInvoiceEdit';
import SalesInvoiceView from '../../../pages/Outbound/SalesInvoice/view-Sales-Invoice/SalesInvoiceView';
import Dashboard from '../../../pages/Outbound/Dashboard/Dashboard';
import SalesReturn from '../../../pages/Outbound/Sales-Return/View-SalesReturn/SalesReturn';
import ViewSalesReturn from '../../../pages/Outbound/Sales-Return/View-SalesReturn/Create';
import EditSalesReturn from '../../../pages/Outbound/Sales-Return/Edit-SalesReturn/Create';
import ViewmainSalesReturn from '../../../pages/Outbound/Sales-Return/Vew-main-SalesReturn/Create';

function OutboundRoute() {
  return (
    <Routes>
      <Route element={<PrivateAuth />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/outbound-sales-order" element={<Salesordermanual />} />
        <Route path="/outbound-create-sales-order" element={<Createsales />} />
        <Route path="/outbound-sales-order-view" element={<SalesOrderView />} />
        <Route path="/outbound-sales-order-edit" element={<EditSalesOrder />} />
        <Route path="/outbound-sales-order-duplicate" element={<DuplicateSalesOrder />} />
        <Route path="pick/createpick" element={<Createpick />} />
        <Route path="/pick/outboundpick" element={<Picklist />} />
        <Route path="putaway/posted-reverse-pick-putaway" element={<Notfound />} />
        <Route path="pick/createpick/new" element={<CreatepickNew />} />
        <Route path="/pick/pick-view" element={<Viewpick />} />
        <Route path="/pick/pick-edit" element={<Editpick />} />
        <Route path="/outbound-delivery-note" element={<Delivery />} />
        <Route path="/outbound-create-delivery-note" element={<Createdelivery />} />
        <Route path="/delivery-note-view" element={<ViewDeliverynote />} />
        <Route path="/delivery-note-edit" element={<EditDeliverynote />} />
        <Route path="/outbound-packingslip" element={<Packingslip />} />
        <Route path="/outbound-create-packingslip" element={<Create />} />
        <Route path="/outbound-packingslip-view" element={<ViewPackSlip />} />
        <Route path="/shippinglist" element={<ShipmentList />} />
        <Route path="/shippinglist-create" element={<ShipmentCreate />} />
        <Route path="/shippinglist-edit" element={<ShipmentEdit />} />
        <Route path="/shippinglist-view" element={<ShipmentView />} />
        <Route path="/outbound/sales-invoice" element={<SalesInvoice />} />
        <Route path="/outbound/create-sales-invoice/" element={<SalesInvoiceCreate />} />
        <Route path="/outbound/edit-sales-invoice/" element={<SalesInvoiceEdit />} />
        <Route path="/outbound/view-sales-invoice/" element={<SalesInvoiceView />} />

        <Route path="/sales-return/" element={<ViewSalesReturn />} />
        <Route path="/edit-sales-return/" element={<EditSalesReturn />} />
        <Route path="/view-sales-return/" element={<ViewmainSalesReturn />} />

        
      </Route>
    </Routes>
  );
}

export default OutboundRoute;
